import React, { Component } from 'react'

import withStyles from "@material-ui/core/styles/withStyles";

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';


import Button from "components/CustomButtons/Button.jsx";

import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
import { faCheck } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CircularProgress } from "@material-ui/core";

import NumberMaskInput from 'components/CustomInput/NumberMaskInput';

import Api from 'api/index.js';
import ProvisioningEndpoints from 'api/ProvisioningEndpoints';

class SetPriceModal extends Component {

    state = {
        loading: false,

        price: 0,
        priceFormatted: '',
        priceState: ''
    }

    changeNum(e, name) {
        this.setState({ [name]: e.target.floatValue, [name + "Formatted"]: e.target.formattedValue, [name + "State"]: (e.target.formattedValue ? "success" : "error") });
    }

    submit = () => {
        Api.post(ProvisioningEndpoints.editPrices,
            {
                ids: this.props.selectedIds,
                newPrice: this.state.price
            }
        )
            .then(({ data }) => {
                console.log(data);
                if (this.props.refresh) {
                    this.props.refresh();
                    this.props.close();
                }
            })
            .catch(e => {
                console.error(e);
            });
    }

    render() {

        return (
            <Dialog
                open={this.props.isOpen}
                onClose={this.props.close}
                fullWidth
                maxWidth="sm"
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="form-dialog-title">Set Selected {this.props.selectedIds.length > 1 ? "Prices" : "Price"}</DialogTitle>
                <DialogContent>
                    <NumberMaskInput
                        success={this.state.priceState === "success"}
                        error={this.state.priceState === "error"}
                        labelText={
                            <span>
                                Price <small>(required)</small>
                            </span>
                        }
                        id="price"
                        formControlProps={{
                            fullWidth: true
                        }}
                        inputProps={{
                            onChange: event => this.changeNum(event, 'price'),
                            value: this.state.priceFormatted
                        }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button style={{ marginRight: 'auto' }} round onClick={this.props.close} color="rose" simple>
                        Cancel
                    </Button>

                    {
                        this.state.loading ?
                            <CircularProgress color="secondary" style={{ marginBottom: 5, marginRight: 10 }} />
                            :
                            <Button
                                onClick={() => this.submit()}
                                color="rose"
                                round
                            >
                                Save Changes
                                &nbsp;&nbsp;
                                <FontAwesomeIcon icon={faCheck} />
                            </Button>
                    }
                </DialogActions>
            </Dialog>
        );
    }
}

export default withStyles(extendedFormsStyle)(SetPriceModal);